<template>
  <el-dialog title="Buy IEO" :visible.sync="isShowBuyForm"
    :closeOnClickModal="false"
    @open="onOpen"
    @submit.prevent.native="buyIeo">
    <el-form :model="form">
      <el-form-item label="Amount" :label-width="formLabelWidth">
        <el-input v-model="form.amount" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div>{{ $t('TEXT_ESTIMATE') }}: {{ estimatedAmount }} {{ selectedBalance.ieoToken }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleModal">{{ $t('BTN_CANCEL') }}</el-button>
      <el-button type="primary" @click="buyIeo" :disabled="!isValidated">{{ $t('BTN_BUY') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UtilService from '@/utils/UtilService'
export default {
  data () {
    return {
      form: {
        amount: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    pagination () {
      return this.$store.getters.pagination
    },
    userConfig () {
      return this.$store.getters.userConfig
    },
    selectedBalance () {
      return this.$store.getters.selectedBalance
    },
    isShowBuyForm: {
      get () {
        return this.$store.getters.isShowBuyForm
      },
      set (val) {
        this.$store.dispatch('toggleIeoForm')
      }
    },
    configs () {
      return this.$store.getters.configs
    },
    isValidated () {
      // return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0
      return true
    },
    account () {
      return this.$store.getters.account
    },
    estimatedAmount () {
      if (!this.isValidated || !this.selectedBalance.symbol) return 0
      return UtilService.calculateAmount(this.form.amount, this.selectedBalance.rate, this.selectedBalance.numberDecimal)
    }
  },
  methods: {
    toggleModal () {
      this.$store.dispatch('toggleIeoForm')
    },
    onOpen () {
    },
    buyIeo () {
      if (!this.isValidated) return
      const body = {
        amount: this.form.amount,
        roundId: this.selectedBalance.roundId,
        symbolToBuy: this.selectedBalance.symbol
      }
      this.$store.dispatch('buyPackage', body).then(rs => {
        console.log(rs)
        if (rs) {
          this.$store.dispatch('toggleIeoForm')
          this.$store.dispatch('getTransHistory', { page: this.pagination.currentPage || 1 })
        }
      })
    }
  }
}
</script>
